package pl.decks.personal.components.widgets.timeline

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette

class TimelineHighlight(
    val span: YearMonth.Range,
    val isOverridingMarker: Boolean = false,
    val monthRenderer: MonthRenderer = MonthRenderer(
        marker = {
            MonthMarkers.RoundedBar(
                Modifier.setVariable(
                    MonthlyTimelineStylesheet.Vars.markerColor,
                    ColorMode.current.toPalette().color,
                )
            )
        },
        label = { ym ->
            if (ym == span.from || ym == span.to) SpanText(ym.month.shortLabel)
        },
    )
)
